<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.docfis_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 15%">Ocorrência</th>
                <th style="width: 15%">Data da Ocorrência</th>
                <th style="width: 15%">Usuario Inc.Ocorrência</th>
                <th style="width: 15%">Obs.</th>
                <th style="width: 10%">Status Integração</th>
                <th style="width: 5%">Unidade</th>
                <th style="width: 15%">Dt.Canc.Ocorr.</th>
                <th style="width: 15%">Motivo Canc.</th>
                <th style="width: 15%">Usuario Canc.</th>
                <th style="width: 15%">Status Ocorrência</th>
                <th style="width: 15%">Foto</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.carga_ocorrencia">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.param_ocorrencia.cd }}
                </td>
                <td>
                  {{ item.param_ocorrencia.descr }}
                </td>
                <td>
                  {{ formatDate(item.dt_ocorrencia) }}
                </td>
                <td>
                  <span>
                    {{ obterNomeOuEmailDoUsuario(item) }}
                  </span>
                </td>
                <td>
                  {{ item.obs }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status_integracao.valor == 1"
                    >{{ item.status_integracao.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="item.status_integracao.valor == 2"
                    >{{ item.status_integracao.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status_integracao.valor == 3"
                    >{{ item.status_integracao.descr }}</span
                  >
                </td>
                <td>
                  <span v-if="item.unidade != null">{{ item.unidade.cd }}</span>
                  <span
                    v-if="
                      item.unidade == null &&
                      item.carga != null &&
                      item.carga.origem_montagem_carga != 2
                    "
                    >{{ item.carga.carga_unidade.unidade.cd }}</span
                  >
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ formatDate(item.carga_ocorrencia_cancelamento.dt_inc) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ item.carga_ocorrencia_cancelamento.param_motivo.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ item.carga_ocorrencia_cancelamento.usuario_cancelamento.pessoa.pessoa_fisica.nome }}
                  </span>
                </td>
                <td>
                  <span class="badge badge-success" v-if="item.status == 1"
                    >Ativo</span
                  >
                  <span class="badge badge-danger" v-if="item.status == 2"
                    >Cancelada</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carocorren_id)"
                    v-b-tooltip
                    title="Ver fotos"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
                <td>
                  <a
                    v-if="
                      getPermissionFw('inclusaoocorrencia.reenvio') &&
                      item.status_integracao.valor == 3
                    "
                    @click="onReenvioErp(item.carocorren_id)"
                    v-b-tooltip
                    title="Reenviar Ocorrência"
                    ><i class="fa fa-reply"></i
                  ></a>
                  <a
                    @click="inativarOcorrencia(item.carocorren_id)"
                    v-b-tooltip
                    title="Inativar Ocorrência"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carocorren_id)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.carocorren_id + ''"
                            role="tab"
                            data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Dados Recebedor
                            <i class="fa fa-puser"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#tr2' + item.carocorren_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Fotos
                            <i class="fa fa-picture-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                          role="tabpanel"
                          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                          v-bind:id="'tr1' + item.carocorren_id + ''"
                      >
                        <table
                            :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                          <tr>
                            <th style="width: 25%">Nome</th>
                            <th style="width: 10%">Documento</th>
                            <th style="width: 10%">Tipo</th>
                            <th style="width: 10%">Latitude da baixa de entrega</th>
                            <th style="width: 10%">Longitude da baixa de entrega</th>
                            <th style="width: 10%">Indicador conforme/não confome ?</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr
                              class="bg-gray-light"
                              style="display: table-row"
                          >
                            <td>
                              {{ item.nome_recebedor}}
                            </td>
                            <td>
                              {{ item.doc_recebedor}}
                            </td>
                            <td>
                              {{ item.tp_recebedor}}
                            </td>
                            <td>
                              {{ item.entrega_lat}}
                            </td>
                            <td>
                              {{ item.entrega_lng}}
                            </td>
                            <td>
                              {{ item.audita_local_entrega}}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.carocorren_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° da foto</th>
                              <th style="width: 35%">Link</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(
                              item_itens, i
                            ) in item.carga_ocorrencia_foto"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ i + 1 }}
                              </td>
                              <td>
                                <a
                                  @click="goLink(item_itens.url_foto)"
                                  target="_blank"
                                  >{{ item_itens.nome_foto }}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <InclusaoOcorrenciaInativarForm ref="inclusaoocorrenciainativarform" />
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import InclusaoOcorrenciaInativarForm from "./InclusaoOcorrenciaInativarForm.vue";

export default {
  components: {
    InclusaoOcorrenciaInativarForm,
  },
  data() {
    return {
      helpForm: new Form({
        recordCollection: [],
        status: "",
        carocorren_id: "",
      }),
      cnpj_formatado: "",
      visibleDetailRows: [],
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    obterNomeOuEmailDoUsuario(cargaOcorrencia) {
      const CTE_CANCELADO = 30

      const strategy = {
        ocorrencia: cargaOcorrencia.param_ocorrencia ? {
          codigo: cargaOcorrencia.param_ocorrencia.cd
        } : null,
        usuarioCancelamento: cargaOcorrencia.doc && cargaOcorrencia.doc.usuario_canc ? {
          email: cargaOcorrencia.doc.usuario_canc.email,
          nome : cargaOcorrencia.doc.usuario_canc.pessoa ? cargaOcorrencia.doc.usuario_canc.pessoa.pessoa_fisica.nome : null
        } : null,
        usuarioIncluido: cargaOcorrencia.usuario_inc ? {
          email: cargaOcorrencia.usuario_inc.email,
          nome : cargaOcorrencia.usuario_inc.pessoa ? cargaOcorrencia.usuario_inc.pessoa.pessoa_fisica.nome : null
        } : null
      };

      if(strategy.ocorrencia.codigo == CTE_CANCELADO && strategy.usuarioCancelamento) {
        return strategy.usuarioCancelamento.nome || strategy.usuarioCancelamento.email;
      }

      return strategy.usuarioIncluido.nome || strategy.usuarioIncluido.email;
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    inativarOcorrencia(data) {
      this.$refs.inclusaoocorrenciainativarform.onCreate(data);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carocorren_id = id;
      this.helpForm
        .patch("/api/inclusaoocorrencia/reenvio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onDetail(carocorren_id) {
      this.toggleDetail(carocorren_id);
    },
    isVisibleDetail(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
    formatDate(value, fmt = 'DD/MM/YYYY HH:mm') {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    goLink(data) {
      window.open(data, "_blank");
    },
  },
};
</script>
